import { v4 as uuidv4 } from 'uuid';
import { Platform } from 'react-native';
import {getDataFromStorage} from '@mmt/legacy-commons/AppState/LocalStorage';
import { LOBS } from '@mmt/legacy-commons/Common/constants/AppConstants';
import {SEARCH_CONTEXT} from './RailsConfig'
import {getCommonHeaders} from '@mmt/legacy-commons/Helpers/genericHelper';
import { getCookieKeyBy, getMWebHeaders } from './Utils/mwebHeaders';
import { getRailsLanguageByKey } from './vernacular/AppLanguage';
import { getPageNameAndEntityNameOfApi, getSessionID, syncSessionID } from './Utils/CommonUtils';
import isEmpty from 'lodash/isEmpty';
import { openBlockScreenIfInGDPRRegion } from '@mmt/legacy-commons/Common/utils/AppUtils';
import {
  LIVE_STATUS_URL,
  RIS_BASE_URL,
  railsTGSHeaderUrl,
} from './pages/RIS/LiveTrainStatus/constants';
import {
  COMMON_LATENCY,
  ENTITY,
  getDataFromAsynStorage,
  ITENERARY_DATA,
  ITENERARY_ID,
  REVIEW_OMNITURE_ERROR_CODES,
  SENTRY_TRACE_ID,
} from './Utils/RailsConstant';
import RailsEnvVariables from 'apps/rails/src/Utils/RailsEnvVariables';
import { getIfCanEnableEnvSwitch } from './RailsAbConfig';
import { logGrafanaErrorMetrics, logGrafanaLatencyMetrics } from './Utils/RailsGrafanaTracker';
import { ENTITY_TYPE, PAGE } from './types/grafanaTracking.types';
import * as Sentry from '@sentry/react-native';
import { RIS_BASE_URL_PNR } from './pages/RIS/Utils/RISAPIUtil';
import md5 from 'md5';

let size = 12;
let interceptors = [];
const railsHeaderUrl = 'rails.makemytrip.com';
const railwaysHeaderUrl = 'railways.makemytrip.com';

export const getLanguageHeaders = () => {
  return {'rails-lang-code': getRailsLanguageByKey("beCode")}
};

function generateRandomID(length) {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const baseHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

let commonHeader = {};
const sourceHeaders = {};

export const initialiseCommonHeaders = async (deepLinkTrackingId = null, deepLinkSource = null) => {
  commonHeader = await getCommonHeaders(baseHeaders);
  if (deepLinkTrackingId) {
    sourceHeaders['mmt-deeplink-tracking-id'] = deepLinkTrackingId;
  }
  if (deepLinkSource) {
    sourceHeaders['mmt-deeplink-source'] = deepLinkSource;
  }
};

function interceptor(fetch, ...args) {
  const startTime = performance.now();
  const readableStartTime = new Date().toLocaleString();
  const reversedInterceptors = interceptors.reduce((array, interceptor) => [interceptor].concat(array), []);
  let promise = Promise.resolve(args);

  // Register request interceptors
  reversedInterceptors.forEach(({request, requestError}) => {
    if (request || requestError) {
      promise = promise.then(args => request(...args), requestError);
    }
  });

  // Register fetch call
  promise = promise.then(async (newArgs) => {
    const traceId = generateRandomID(size);
    const [url, headersObject = {}, ...rest] = newArgs;

    const { pageName, entityName } = getPageNameAndEntityNameOfApi(url);

    let interceptedUrl = url;
    const canChangeBaseUrl = RailsEnvVariables.getCanChangeBaseUrl() && getIfCanEnableEnvSwitch();
    if (canChangeBaseUrl && interceptedUrl.includes('pwa/mobile')) {
      interceptedUrl = `${RailsEnvVariables.getPWABaseUrl()}/pwa/mobile${url
        .split('/pwa/mobile')
        .pop()}`;
    } else if (
      canChangeBaseUrl &&
      !interceptedUrl.includes('pwa/mobile') &&
      !interceptedUrl.includes('/api/ris/') &&
      !interceptedUrl.includes('/api/rails/') &&
      !interceptedUrl.includes('mbus') &&
      interceptedUrl.includes('/api')
    ) {
      interceptedUrl = `${RailsEnvVariables.getNodeBaseUrl()}/api${url.split('/api').pop()}`;
    }
    let editedHeadersObject;
    const oldHeaders = headersObject ? headersObject.headers : null;
    if (
      url.includes(railsHeaderUrl) ||
      url.includes(LIVE_STATUS_URL) ||
      url.includes(railsTGSHeaderUrl) ||
      url.includes(railwaysHeaderUrl) ||
      url.includes(RIS_BASE_URL) ||
      url.includes(RIS_BASE_URL_PNR)
    ) {
      if (isEmpty(commonHeader)) {
        await initialiseCommonHeaders();
      }
      await syncSessionID();
      const sessionId = await getSessionID();
      editedHeadersObject = {
        ...headersObject,
        headers: {
          ...commonHeader,
          ...sourceHeaders,
          ...getLanguageHeaders(),
          ...oldHeaders,
          'session-id': sessionId,
          'X-Trace-Id': traceId,
          'mmt-os': Platform.OS,
        },
      };
      const searchContext = await getDataFromStorage(SEARCH_CONTEXT);
      const iteneraryData = await getDataFromAsynStorage(ITENERARY_DATA);
      if (searchContext) {
        editedHeadersObject['headers'][SEARCH_CONTEXT] = JSON.stringify(searchContext);
      }
      if (iteneraryData) {
        editedHeadersObject['headers'][ITENERARY_ID] = JSON.stringify(iteneraryData[ITENERARY_ID]);
      }
      // if(Platform.OS !== 'web'){
        try {
          const sentryTraceId = Sentry.getCurrentHub()?.getScope()?.getPropagationContext()?.traceId;
          if (sentryTraceId) {
            editedHeadersObject.headers[SENTRY_TRACE_ID] = sentryTraceId;
          }
          // Sentry.setTag('deviceID', editedHeadersObject.headers['mmt-device-id']);
        } catch (error) {
          //ignore
        }
      // }
    } else {
      editedHeadersObject = headersObject;
    }

    if (Platform.OS === 'web') {
      const mwebHeaders =  await getMWebHeaders();
      editedHeadersObject = {
        ...editedHeadersObject,
        headers: {
          ...editedHeadersObject.headers,
          ...mwebHeaders
        },
      };
    }
    const fetchArgs = [interceptedUrl, editedHeadersObject, ...rest];

    return await fetchData({fetchArgs, pageName, entityName, readableStartTime, startTime, traceId, retryCount: 1});
  });

  // Register response interceptors
  reversedInterceptors.forEach(({response, responseError}) => {
    if (response || responseError) {
      promise = promise.then(response, responseError);
    }
  });
  return promise;
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function fetchData ({fetchArgs, pageName, entityName, readableStartTime, startTime, traceId, retryCount = 1}) {
  const newTraceId = `${traceId?.slice?.(0, -1)}${retryCount}`;
  const editedHeadersObject = fetchArgs?.[1]?.headers;
  if (editedHeadersObject) {
      editedHeadersObject['X-Trace-Id'] = newTraceId;
  }
  try {
    const response = await fetch(...fetchArgs);
    if (response.status === 403 && response?.headers?.map?.isgdpr === 'true') {
      await openBlockScreenIfInGDPRRegion(LOBS.TRAIN, true, LOBS.TRAIN);
    }

    const latency = performance.now() - startTime;
    logGrafanaLatencyMetrics(
      pageName,
      ENTITY_TYPE.API,
      entityName,
      COMMON_LATENCY.TOTAL,
      latency,
    );
    return response;
  } catch (error) {
    if (entityName === "bookingReview") {
      const readableEndTime = new Date().toLocaleString();
      const latency = performance.now() - startTime;
      const cookieKeyBy = getCookieKeyBy();
      const errorMessage = {
        readableStartTime,
        readableEndTime,
        clarityId: `${(cookieKeyBy?.["mmt-uuid"] ? md5(cookieKeyBy["mmt-uuid"]) : null) || (cookieKeyBy?.["dvid"] ? md5(cookieKeyBy["dvid"]) : null) || "nil"}`,
        traceId,
        sessionId: await getSessionID(),
        commonHeader,
        errorDetails: error?.message || "DEFAULT_ERROR",
      }
      logGrafanaErrorMetrics(PAGE.TRAVELLER, ENTITY_TYPE.COMPONENT, ENTITY.REVIEW_VISIT_LATER_OMNI_ERROR, JSON.stringify(errorMessage), REVIEW_OMNITURE_ERROR_CODES.f);
      logGrafanaLatencyMetrics(
        PAGE.TRAVELLER,
        ENTITY_TYPE.API,
        "bookingReviewError",
        COMMON_LATENCY.TOTAL,
        latency,
      );
      if (retryCount < 3) {
        await sleep(retryCount * 2500);
        return fetchData({fetchArgs, pageName, entityName, readableStartTime, startTime, traceId, retryCount: retryCount + 1});
      }
    } else {
      const readableEndTime = new Date().toLocaleString();
      const cookieKeyBy = getCookieKeyBy();
      const errorMessage = {
        readableStartTime,
        readableEndTime,
        clarityId: `${(cookieKeyBy?.["mmt-uuid"] ? md5(cookieKeyBy["mmt-uuid"]) : null) || (cookieKeyBy?.["dvid"] ? md5(cookieKeyBy["dvid"]) : null) || "nil"}`,
        traceId,
        sessionId: await getSessionID(),
        commonHeader,
        errorDetails: error?.message || "DEFAULT_ERROR",
      }
      logGrafanaErrorMetrics(pageName, ENTITY_TYPE.COMPONENT, entityName, JSON.stringify(errorMessage), '6007');
    }
    const beErrorCode = error?.errorDetails?.errorCode || 'Rails_No_BE';
    const combinedError = {
      ...error,
      errorCode: `${beErrorCode}.${newTraceId}`,
    };
    
    throw combinedError;
  }
}

export const addInterceptor = (interceptor, deepLinkTrackingId, deepLinkSource) => {
  interceptors.push(interceptor);
  initialiseCommonHeaders(deepLinkTrackingId, deepLinkSource);
  return () => {
    const index = interceptors.indexOf(interceptor);
    if (index >= 0) {
      interceptors.splice(index, 1);
    }
  };
};

export const clearInterceptors = () => {
  interceptors = [];
};

export const Timeout = (time) => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), time * 1000);
  return controller;
};

const fetch2 = (...args) => interceptor(fetch, ...args);

export default fetch2;
